import { combineReducers } from "redux";

import gallery from "../features/admin/gallerys/gallery/Slice";

import common from "../features/admin/common/Slice";

const gallerys = combineReducers({
  gallery,
  common,
});

export default gallerys;
